import { useEffect } from "react";
import { Navigate, Outlet, useParams } from "react-router";
import { toast } from "sonner";
import { useInventionElements } from "@/hooks/use-invention";

/** The server's words for a shut Novelty, repeated here so the toast and the gate agree. */
export const NOVELTY_SHUT = "Confirm the elements first";

/**
 * The novelty page is shut on the server while the elements are
 * not confirmed, so it is not shown either: a definite unconfirmed answer sends
 * the attorney back to Invention and says why, once. An unanswered read lets
 * the page through, since a redirect off nothing would bounce every cold load.
 * The toast's id keeps a mount effect run twice (StrictMode) to one toast.
 */
export function NoveltyGuard() {
  const { taskId } = useParams<{ taskId: string }>();
  const { data } = useInventionElements(taskId ?? null);
  const shut = data !== undefined && !data.gate.settled;
  useEffect(() => {
    if (shut) toast.info(NOVELTY_SHUT, { id: "novelty-shut" });
  }, [shut]);
  return shut ? <Navigate to="../invention" replace /> : <Outlet />;
}
